import React from 'react';
import styled from '@emotion/styled';
import ReactMarkdown from 'react-markdown';

const Container = styled.div`
  min-height: 100vh;
  background-color: #f5f5f7;
  padding: 2rem;
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  max-width: 800px;
  margin: 0 auto;
  background: white;
  padding: 2rem;
  border-radius: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  flex: 1;
`;

const Title = styled.h1`
  color: #1d1d1f;
  margin-bottom: 2rem;
  font-size: 2rem;
  text-align: center;
`;

const MarkdownContainer = styled.section`
  margin-bottom: 2rem;
  h1 {
    color: #1d1d1f;
    margin-bottom:0.5rem;
    font-size: 1.5rem;
  }
  h2 {
    color: #1d1d1f;
    margin-bottom: 0.5rem;
    font-size: 1.0rem;
  }

  p {
    color: #6e6e73;
    line-height: 1.6;
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
  }
`;

const Footer = styled.footer`
  text-align: center;
  padding: 1rem 0;
  color: #86868b;
  font-size: 0.9rem;
`;

function CleanTextAiPrivacyPolicyEn() {
  const currentYear = new Date().getFullYear();
  const markdownContent = `
 # Privacy Policy

"Study AI" (hereinafter referred to as "this app") respects users' privacy and takes maximum care to protect personal information. This app does not collect users' personal information and takes measures to protect users' data. This Privacy Policy (hereinafter referred to as "this Policy") sets forth the handling of information in this app.

## Article 1 (Collection and Management Policy of Personal Information)

This app does not collect any personal information (such as name, address, phone number, email address, etc.) from users. All functions within the app are designed on the premise that no personal information will be collected. Also, to protect users' privacy, we do not collect or store any information that can identify individuals in accordance with personal information protection laws.

## Article 2 (Storage of Homework and Exam Images and Data)

In this app, all homework and exam images photographed by users, scanned documents, and data after handwriting removal processing are stored only on the user's device and are not stored on external servers. Therefore, we have no access to images and data photographed and stored by users. We also guarantee that these image data will not be provided to third parties and will be safely stored on the user's device.

## Article 3 (AI Problem-Solving Function)

This app provides a function to obtain answers by sending problem images photographed by users to AI. When using this function, problem images are temporarily sent to external AI services, but they do not contain personally identifiable information. The sent images are deleted after answer processing and are not stored long-term. Also, AI service providers do not use these images for other purposes. This function is optional, and users can stop using it at any time.

## Article 4 (Camera and Photo Library Access)

This app may request permission to access the user's device camera and photo library to provide photography and scanning functions for homework and exam problems. These permissions are used only to execute the app's basic functions, and we do not access users' photos or camera functions without permission. Also, access permissions can be changed or revoked by users at any time from their device settings.

## Article 5 (Data Encryption and Security)

This app uses appropriate encryption technology for all data stored within the device to protect user data. Also, we implement regular security updates to minimize security risks that may occur during app usage. However, users are responsible for appropriate management of their device's security.

## Article 6 (App Usage Analysis)

This app may analyze app usage (frequency of function usage, error occurrence status, etc.) within a range that cannot identify individuals for service improvement. These analysis data do not include personal information, and only statistical information is collected and used solely for app improvement and new feature development.

## Article 7 (Integration with Third-Party Services)

This app uses third-party AI services for the AI problem-solving function. These service providers have their own privacy policies, and user data handling follows each service provider's policy. This app minimizes data sent to these third-party services and ensures that no personal information is included.

## Article 8 (User Rights and Data Management)

This app ensures that users can fully manage their own data. Users can delete data within the app at any time, and this app will not send data externally unless operated by the user (except for the AI problem-solving function). Also, since we do not use personal information when using this app according to the Terms of Service, requests for disclosure, correction, deletion, or suspension of use of information do not apply.

## Article 9 (Response to Legal Requests)

Since this app does not collect personal information, we generally cannot respond to information disclosure requests from law enforcement agencies. However, if there are legally valid warrants or court orders, we will respond appropriately in accordance with laws and regulations.

## Article 10 (Changes to Privacy Policy)

This app may review the contents of this Policy from time to time and change this Policy in accordance with amendments to laws and changes in app functions to improve user privacy protection. When changes are made, users will be notified by posting the latest privacy policy within this app, and it will take effect simultaneously with the posting. Users are requested to check this Policy periodically.

## Article 11 (Contact Information)

If you have any questions or concerns about this Policy, please contact us at the following address. If you have any privacy-related questions or concerns, please feel free to contact us.

Email: linappworks@gmail.com

Last Updated: August 20, 2025
  `;

  return (
    <Container>
      <Content>
        <Title>Privacy Policy</Title>
        <MarkdownContainer>
          <ReactMarkdown>{markdownContent}</ReactMarkdown>
        </MarkdownContainer>
      </Content>
      <Footer>
        <p>© {currentYear} linappworks. All rights reserved.</p>
        <p>Contact us: linappworks@gmail.com</p>
      </Footer>
    </Container>
  );
}

export default CleanTextAiPrivacyPolicyEn; 